export const USER_STATUS_LAST_REMAINING_ADMIN_DISABLE_TOOLTIP = 'This user cannot be disabled because they are the only admin in one of the organisations they belong to. Manage their status manually in edit mode.';
export const USER_STATUS_ASSIGNED_TO_APPROVAL_UNITS_DISABLE_TOOLTIP = `
	This user cannot be disabled because they are assigned to the Approval Units. 
	Please remove them from the Approval Units first.
`;
export const USER_STATUS_COMBINED_RESTRICTION_DISABLE_TOOLTIP = `
	This user cannot be disabled because they are assigned to 
	Approval Units and are the only admin in one of their organisations. 
	To proceed, first remove them from the Approval Units and manage their admin status manually in edit mode.
`;

export const USER_STATUS_DISABLE_TOOLTIP = 'Disable user';

export const DELETE_USER_TOOLTIP = 'Delete user from this organisation';
export const DELETE_USER_LAST_REMAINING_ADMIN_DISABLE_TOOLTIP = `
	You can't delete the user from this organisation because 
	there are no more Admins in this organisation
`;
export const DELETE_USER_ASSIGNED_TO_APPROVAL_UNITS_DISABLE_TOOLTIP = `
	This user cannot be deleted because they are assigned to the Approval Units. 
	Please remove them from the Approval Units first.
`;
export const DELETE_USER_COMBINED_RESTRICTION_TOOLTIP = `
	This user cannot be deleted because they are assigned to 
	Approval Units and are the only admin in one of their organisations. 
	To proceed, first remove them from the Approval Units and manage their admin status manually in edit mode.
`;

export const EDIT_USER_TOOLTIP = 'Edit roles';
export const EDIT_USER_NON_ACTIVE_TOOLTIP = 'You can\'t edit roles (non-active) because organisations is inactive';

export const USER_STATUS_NAME = 'userStatus';
